// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"df24ef88","490":"ea05ca06"}[chunkId] + ".chunk.css";
};